import { useRef } from 'react';
import { useScroll } from 'react-use';
import { Button, Text } from '~/rs-components/elements';

export function CartEmpty({ onClose }: { onClose?: () => void }) {
  const scrollRef = useRef(null);
  const { y } = useScroll(scrollRef);

  return (
    <div
      ref={scrollRef}
      className={`grid content-start gap-4 px-6 pb-8 transition overflow-y-scroll md:gap-12 md:px-12 h-screen-no-nav md:pb-12 ${y > 0 && 'border-t'
        }`}
    >
      <section className="grid gap-6">
        <Text format>
          Looks like you haven&rsquo;t added anything yet, let&rsquo;s get you
          started!
        </Text>
        <div>
          {/* <Button onClick={onClose}>Continue shopping</Button> */}
          <button className='black-button' onClick={onClose}>Continue shopping</button>
        </div>
      </section>
    </div>
  );
}